import { Stack } from "@mantine/core";
import { AccountProductPreferences } from "../../hooks/useAccountProductPreferences";
import { LabPreferences } from "./components/LabPreferences";
import { NotificationPreferences } from "./components/NotificationPreferences";
import { OcclusionPreferences } from "./components/OcclusionPreferences";
import { ShadePreferences } from "./components/ShadePreferences";
import { useGeneralPreferenceForm } from "./useGeneralPreferenceForm";

const GeneralPreference = ({
  selectedPreferences,
  selectedUser,
}: {
  selectedPreferences: AccountProductPreferences | undefined;
  selectedUser: string;
}) => {
  const form = useGeneralPreferenceForm(selectedPreferences, selectedUser);

  return (
    <form>
      <Stack pb="s16">
        <ShadePreferences form={form} />

        <OcclusionPreferences form={form} />

        <LabPreferences form={form} />

        <NotificationPreferences form={form} />
      </Stack>
    </form>
  );
};

export default GeneralPreference;
